import { defineComponent as t, openBlock as c, createBlock as d, unref as o, mergeProps as l, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const v = /* @__PURE__ */ t({
  name: "IconReassuranceCalendar30Days",
  __name: "IconReassuranceCalendar30Days",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const r = n;
    return (i, a) => (c(), d(o(s), l(r, { "view-box": "0 0 48 48" }), {
      default: p(() => [...a[0] || (a[0] = [
        e("g", { "clip-path": "url(#2e236ee4-9b1c-4c57-a55b-1ed8f1ef69bda)" }, [
          e("path", { d: "M13.51 28.91h2.56a1.92 1.92 0 0 0 2.1 1.85 1.89 1.89 0 0 0 2.09-1.87c0-1.28-.86-1.78-2.39-1.78H17.2v-1.95h.45c1.57 0 2.32-.7 2.32-1.78a1.65 1.65 0 0 0-1.8-1.67 1.77 1.77 0 0 0-1.89 1.87h-2.54c.08-2.32 1.59-3.8 4.47-3.8s4.3 1.66 4.3 3.49A2.77 2.77 0 0 1 20.6 26a2.94 2.94 0 0 1 2.2 2.94c0 2.18-1.62 3.8-4.59 3.8s-4.66-1.51-4.7-3.83" }),
          e("path", {
            "fill-rule": "evenodd",
            d: "M29.51 19.78c-2.54 0-4.88 1.69-4.88 6.46 0 4.76 2.32 6.47 4.88 6.47s4.88-1.7 4.88-6.47-2.34-6.46-4.88-6.46m0 2.03c1.27 0 2.27 1.05 2.27 4.43 0 3.39-1 4.43-2.27 4.43s-2.27-1.05-2.27-4.43 1-4.43 2.27-4.43",
            "clip-rule": "evenodd"
          }),
          e("path", {
            "fill-rule": "evenodd",
            d: "M32 6H16V2a2 2 0 1 0-4 0v4H5.83A5.87 5.87 0 0 0 0 11.9v30.2A5.87 5.87 0 0 0 5.83 48h36.34A5.87 5.87 0 0 0 48 42.1V11.9A5.87 5.87 0 0 0 42.17 6H36V2a2 2 0 1 0-4 0v4M5.83 10h36.34A1.87 1.87 0 0 1 44 11.9v30.2a1.87 1.87 0 0 1-1.83 1.9H5.83A1.87 1.87 0 0 1 4 42.1V11.9A1.87 1.87 0 0 1 5.83 10",
            "clip-rule": "evenodd"
          })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "2e236ee4-9b1c-4c57-a55b-1ed8f1ef69bda" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
